import { NavLink, useSearchParams } from 'react-router-dom'
import './DetailsColumn.css'
import { EyeIcon } from '@heroicons/react/24/outline'

type Props = {
  path: string
  iconOnly?: boolean
}

export const DetailsColumn: React.FC<Props> = ({ path, iconOnly = false }) => {
  const [searchParams] = useSearchParams()
  const net = searchParams.get('net')

  // Use URL API to handle any existing query in path
  const url = new URL(path, window.location.origin) // Needs absolute base
  if (net) {
    url.searchParams.set('net', net)
  }

  const finalPath = url.pathname + url.search

  return (
    <NavLink to={finalPath} className="details-button" title="View Details">
      <EyeIcon className="details-icon" /> {iconOnly ? '' : 'View'}
    </NavLink>
  )
}
